module.exports = __webpack_public_path__ + "img/player-icon.7e10a4c.png";